export default "__VITE_ASSET__3f22c712__"